export function useResolvedImage(imagePath: string) {
  const resolvedImage = computed(() => {
    if (imagePath.startsWith('@')) {
      return new URL(imagePath.replace('@', '/src'), import.meta.url).href
    }
    return new URL(imagePath, import.meta.url).href
  })

  return resolvedImage
}
